<script lang="ts">
	import type { CloudImage } from "$lib/def/seo/cloud-image";
	import type { Options } from "flickity";
	
	import { getCimgUrl, getImgUrl } from "$lib/serv/admin/editImg";
	
	import Carousel from "$lib/ui/layout/Carousel.svelte";
	import LazyBackgroundImage from "../LazyBackgroundImage.svelte";
import { imgSrc, toSrc } from "$lib/serv/image-details";

	export let title: string;
	export let list: undefined | {slug: string, name?: string, icon?: string}[];
	// export let images: CloudImage[];

	const options: Options & { fade: boolean } = {
		freeScroll: true,
		wrapAround: false,
		groupCells: true,
		pageDots: false,
		prevNextButtons: true,
		draggable: true,
		selectedAttraction: 0.025,
		friction: 0.28,
		fade: false,
	}
</script>

<Carousel cache={{ loading: !list, payload: list}} type="filters primary" key={l => l.filter(({icon}) => Boolean(icon))} {options} let:item={item}>
	<h4 slot="title" class="headline-m bold">{title}</h4>
	<a href={`/delivery/of/${item.slug}`} class="item" style="margin-top: -16px;">
		<LazyBackgroundImage image={imgSrc(item.icon??'', '160x0')} alt={item.name ?? ''} />
		<div class="label-xl medium" style="margin-left: -15%; margin-right: -15%;">{item.name}</div>
	</a>
</Carousel>
